let sequence = 0;

export const DEFAULT_ADMIN_PASSWORD = 'muyuan';

// Keep default navigation targets aligned with the legacy navigation source at https://a.jxmuyuan.com/api.php?path=all.
export const RAW_GROUPS = [
  { id: 'common', name: '常用', desc: '高频办公入口', items: [
    ['万里牛', '电商 ERP', 'https://erp.hupun.com/'],
    ['江西木源 · 生产ERP', '生产排程', 'https://erp.jxmuyuan.com:6089/sysn/view/init/home.ashx?dvn=1776016421871'],
    ['企微云文档', '协作文档', 'https://doc.weixin.qq.com/home/space/1/s.1970325457002900.7495364596x1/all'],
    ['木源 SOP 文档', '标准流程', 'http://10.10.10.41/sop/'],
    ['汉码 · 标签打印', '条码标签', 'https://hm.hprt.com/label'],
    ['京东物流', '物流下单', 'https://wl.jdl.com/'],
    ['顺丰快递', '寄件查询', 'https://v.sf-express.com/web/laas/admin/express/dashboard'],
    ['财务专家', '财务记账', 'https://system.caiwu369.com/home.aspx'],
    ['江西税务', '电子税务局', 'https://etax.jiangxi.chinatax.gov.cn/'],
    ['邮政快递', 'EMS 寄递', 'https://my.ems.com.cn/pcp-vue/ZHGL/ZZFWPH'],
    ['字体天下', '商用字体', 'https://www.fonts.net.cn/'],
    ['靖安就业网', '招聘用工', 'https://ja.yc9y.com/company/jobs/list'],
  ] },
  { id: 'shops', name: '公司店铺', desc: '4 家自营店铺', items: [
    ['淘宝 · 木源MUYUAN', '淘宝 C 店', 'https://mywood.jiyoujia.com/'],
    ['天猫 · 晌木时光', '天猫旗舰', 'https://shangmushiguang.tmall.com/'],
    ['京东 · 晌木时光', '京东自营', 'https://mall.jd.com/index-12035697.html?from=pc'],
    ['阿里 · 晌木时光', '1688 批发', 'https://smsg2020.1688.com/'],
  ] },
  { id: 'backend', name: '商家后台', desc: '11 个经营后台', items: [
    ['千牛工作台', '淘宝天猫', 'https://myseller.taobao.com/'],
    ['万相台无界版', '广告投放', 'https://one.alimama.com/index.html'],
    ['1688 工作台', '批发经营', 'https://work.1688.com/home/seller.htm'],
    ['京东工作台', '京东商家', 'https://shop.jd.com/jdm/home/'],
    ['抖店工作台', '抖音电商', 'https://fxg.jinritemai.com/login/common'],
    ['拼多多工作台', 'PDD 商家', 'https://mms.pinduoduo.com/'],
    ['小红书工作台', '小红书店', 'https://ark.xiaohongshu.com/'],
    ['Shopee 全托管', '跨境托管', 'https://seller.scs.shopee.cn/'],
    ['TEMU', '跨境半托', 'https://seller.kuajingmaihuo.com'],
    ['抖音企业号', '内容运营', 'https://leads.cluerich.com/'],
    ['微信视频号助手', '视频号', 'https://channels.weixin.qq.com/'],
  ] },
  { id: 'platform', name: '电商平台', desc: '前台购物站点', items: [
    ['淘宝网', '前台', 'https://www.taobao.com/'],
    ['京东商城', '前台', 'https://www.jd.com/'],
    ['阿里巴巴', '前台', 'https://www.1688.com/'],
  ] },
  { id: 'ai', name: 'AI 工具', desc: '12 个智能助手', items: [
    ['AI-Server', '内部算力', 'http://10.10.10.12:6262/jxmuyuan'],
    ['OpenClaw', '自动化', 'http://10.10.10.12:18789/chat?session=agent%3Amain%3Adirect%3Ayy'],
    ['ChatGPT', 'OpenAI', 'https://chatgpt.com'],
    ['Google AI Studio', 'Gemini', 'https://aistudio.google.com/prompts/new_chat?project=gen-lang-client-0594873182'],
    ['Claude Code', 'Anthropic', 'https://claude.ai/'],
    ['阿里云百炼', '模型服务', 'https://bailian.console.aliyun.com/cn-beijing/?spm=5176.29597918.J_SEsSjsNv72yRuRFS2VknO.2.49aa133c81eUbA&tab=model#/model-market/all'],
    ['DeepSeek', '深度求索', 'https://platform.deepseek.com/usage'],
    ['Kimi', '月之暗面', 'https://www.kimi.com/agent'],
    ['智谱清言', 'GLM', 'https://chatglm.cn/'],
    ['美图', '图像处理', 'https://www.designkit.cn/product-kit'],
    ['即梦 AI', '图像生成', 'https://jimeng.jianying.com/ai-tool/home/?utm_medium=baiduads&utm_source=pinzhuan&utm_campaign=title'],
    ['通义万相', '文生图', 'https://tongyi.aliyun.com/wan/explore'],
  ] },
  { id: 'docs', name: '企微云文档', desc: '产品资料中心', items: [
    ['企微云文档', '总览', 'https://doc.weixin.qq.com/home/space/1/s.1970325457002900.7495364596x1/all'],
    ['产品定制', '定制单', 'https://doc.weixin.qq.com/smartsheet/s3_AUAANwZjAMoCNEMRGftWqTxu7B85C?scode=AJQA4Qf0ACQI4oG2KBAUAANwZjAMo&tab=h6BPgp&viewId=v7EOrK'],
    ['产品定制价格', '报价表', 'https://doc.weixin.qq.com/sheet/e3_AXwAyQbxAA8CNQzc6KCCcRBWRuX1W?scode=AJQA4Qf0ACQnP9yhQhAXwAyQbxAA8&tab=000003'],
    ['产品信息', '资料库', 'https://doc.weixin.qq.com/sheet/e3_AXwAyQbxAA8CNCtkw15auS2uYzDB0?scode=AJQA4Qf0ACQeaqa316AXwAyQbxAA8&tab=BB08J2'],
  ] },
  { id: 'utils', name: '实用工具', desc: '研发与杂项', items: [
    ['专利检索', '知识产权', 'https://pss-system.cponline.cnipa.gov.cn/conventionalSearch'],
    ['专利业务办理', '专利申报', 'https://cponline.cnipa.gov.cn/'],
    ['包小盒', '包装设计', 'https://www.baoxiaohe.com/'],
    ['iconfont', '图标库', 'https://www.iconfont.cn/'],
    ['Gitea', '代码仓库', 'http://10.10.10.41:3000/explore/repos'],
  ] },
];

const PIN_NAMES = ['千牛工作台', '万里牛', '抖店工作台', '企微云文档', '京东工作台', 'DeepSeek', '拼多多工作台', '江西木源 · 生产ERP'];

function hashString(value) {
  let hash = 2166136261;
  for (const char of String(value || '')) {
    hash ^= char.codePointAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
}

function logoSlug(name) {
  const words = String(name || '').toLowerCase().match(/[a-z0-9]+/g) || [];
  const slug = words.slice(0, 3).join('-') || 'logo';
  return `${slug}-${hashString(name)}`;
}

export function localLogoPathForName(name) {
  return `/assets/logos/${logoSlug(name)}.png`;
}

const DEFAULT_ITEM_NAMES = new Set(RAW_GROUPS.flatMap((group) => group.items.map(([name]) => name)));

function defaultLogoForName(name) {
  return DEFAULT_ITEM_NAMES.has(name) ? localLogoPathForName(name) : '';
}

export const EMPTY_PREFS = { catOrder: [], itemOrder: {}, pins: null };

export function uid(prefix = 'k') {
  // Defaults are rebuilt often in tests and migrations; the sequence only needs to prevent duplicate ids within one rebuild.
  sequence += 1;
  return `${prefix}_${Date.now().toString(36)}_${sequence}`;
}

export function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

export function toNavigationUrl(value) {
  const url = String(value || '').trim();
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

export function buildDefaultConfig() {
  sequence = 0;
  const groups = RAW_GROUPS.map((group) => ({
    id: group.id,
    name: group.name,
    desc: group.desc,
    items: group.items.map(([name, note, url]) => ({
      id: uid('it'),
      name,
      note,
      url: toNavigationUrl(url),
      icon: defaultLogoForName(name),
      newTab: true,
    })),
  }));
  const all = groups.flatMap((group) => group.items);
  const pins = PIN_NAMES.map((name) => all.find((item) => item.name === name)?.id).filter(Boolean);

  return {
    version: 1,
    revision: 0,
    site: {
      name: '晌木时光',
      subtitle: '工作台 · 看板',
      logoText: '木',
      logoImg: '',
      location: '靖安 · 江西',
      team: '木源运营组',
    },
    theme: 'warm',
    layout: [
      { id: 'clock', visible: true },
      { id: 'promo', visible: true },
      { id: 'announce', visible: true },
      { id: 'todos', visible: true },
      { id: 'pins', visible: true },
      { id: 'nav', visible: true },
    ],
    promotion: {
      text: '2026年淘宝 天猫 618狂欢节\n● 售卖05/31 00:00:00 - 06/21 23:59:59\n● 下单立减15%',
    },
    weather: { enabled: true, cond: '晴', icon: '100', tempNow: 26, tempHigh: 26, tempLow: 18, humidity: 60, todayText: '晴', todayTextDay: '晴', todayTextNight: '晴' },
    groups,
    pins,
    announcements: [
      { id: uid('an'), tag: '运营', text: '618 大促复盘会今天 15:00 · 三楼会议室,各店铺负责人参加' },
      { id: uid('an'), tag: '物流', text: '顺丰月结对账单已生成,请于本周五前确认' },
      { id: uid('an'), tag: 'IT', text: '内部 AI-Server 已升级至新版本,支持更长上下文' },
    ],
    todos: [
      { id: uid('td'), text: '天猫旗舰店主图改版上线', done: false, due: '今天' },
      { id: uid('td'), text: '核对拼多多到账金额', done: false, due: '今天' },
      { id: uid('td'), text: '提交 8 月新品定制报价', done: true, due: '昨天' },
      { id: uid('td'), text: '专利「可拆装木质收纳」补正材料', done: false, due: '6/9' },
    ],
  };
}

export function migrateConfig(config) {
  const defaults = buildDefaultConfig();
  const next = Object.assign({}, defaults, config || {});
  next.site = Object.assign({}, defaults.site, next.site || {});
  next.weather = Object.assign({}, defaults.weather, next.weather || {});
  next.promotion = Object.assign({}, defaults.promotion, next.promotion || {});
  next.promotion.text = String(next.promotion.text || '');
  if (next.theme === true) next.theme = 'dark';
  if (next.theme === false || next.theme === 'light') next.theme = 'warm';

  // Preserve admin-saved block order/visibility while appending any new default blocks added by future releases.
  const knownLayoutIds = new Set(defaults.layout.map((block) => block.id));
  const mergedLayout = [];
  for (const block of Array.isArray(next.layout) ? next.layout : []) {
    if (block && knownLayoutIds.has(block.id) && !mergedLayout.some((entry) => entry.id === block.id)) {
      mergedLayout.push({ id: block.id, visible: block.visible !== false });
    }
  }
  const defaultLayoutIds = defaults.layout.map((block) => block.id);
  const insertMissingLayoutBlock = (block) => {
    const defaultIndex = defaultLayoutIds.indexOf(block.id);
    let insertAt = mergedLayout.length;
    let foundAnchor = false;
    for (let i = defaultIndex - 1; i >= 0; i -= 1) {
      const predecessorIndex = mergedLayout.findIndex((entry) => entry.id === defaultLayoutIds[i]);
      if (predecessorIndex >= 0) {
        insertAt = predecessorIndex + 1;
        foundAnchor = true;
        break;
      }
    }
    if (!foundAnchor) {
      for (let i = defaultIndex + 1; i < defaultLayoutIds.length; i += 1) {
        const successorIndex = mergedLayout.findIndex((entry) => entry.id === defaultLayoutIds[i]);
        if (successorIndex >= 0) {
          insertAt = successorIndex;
          foundAnchor = true;
          break;
        }
      }
    }
    mergedLayout.splice(insertAt, 0, { id: block.id, visible: true });
  };
  for (const block of defaults.layout) {
    if (!mergedLayout.some((entry) => entry.id === block.id)) {
      insertMissingLayoutBlock(block);
    }
  }
  next.layout = mergedLayout;

  // Older configs may contain host-only items; normalize them to the current url/newTab/icon shape.
  next.groups = Array.isArray(next.groups) ? next.groups : defaults.groups;
  for (const group of next.groups) {
    group.id ||= uid('g');
    group.items = Array.isArray(group.items) ? group.items : [];
    for (const item of group.items) {
      item.id ||= uid('it');
      if (item.url == null && item.host) item.url = toNavigationUrl(item.host);
      if (item.newTab == null) item.newTab = true;
      if (!item.icon) item.icon = defaultLogoForName(item.name);
    }
  }
  next.pins = Array.isArray(next.pins) ? next.pins : defaults.pins;
  next.announcements = Array.isArray(next.announcements) ? next.announcements : defaults.announcements;
  next.todos = Array.isArray(next.todos) ? next.todos : defaults.todos;
  return next;
}
